document.addEventListener('DOMContentLoaded', () => {
  const productsContainer = document.getElementById('KyariProductsContainer');
  if (!productsContainer) return;

  const builderEl = productsContainer.closest('.kyari-bundle-builder');
  const bundlePriceCents = parseInt(builderEl ? builderEl.dataset.bundlePrice : '0', 10) || 0;
  const editNameAttr = builderEl ? (builderEl.dataset.editName || 'Kyārī Edit') : 'Kyārī Edit';

  const sizeKeywords = ['queen', 'king', 'cal king', 'double', 'twin'];
  const state = {
    step: 1,
    size: null,
    selections: {}
  };

  const cards = Array.from(productsContainer.querySelectorAll('.kyari-product-card'));

  let hasSizes = false;
  const types = new Set();

  cards.forEach(card => {
    const type = card.dataset.productType || 'Curated Item';
    types.add(type);

    const kw = (card.dataset.productKeywords || "").toLowerCase();
    if (sizeKeywords.some(size => kw.includes(size))) {
      hasSizes = true;
      card.dataset.hasSizes = 'true';
    }
  });

  productsContainer.innerHTML = '';
  const funnelBlocks = [];
  let currentStepNum = 1;
  const sizeStepIndex = hasSizes ? currentStepNum : null;

  if (hasSizes) {
    const sizeStep = createStepContainer(currentStepNum, 'Select Bedding Size');
    const sizeGrid = document.createElement('div');
    sizeGrid.className = 'kyari-size-grid';

    ['Queen', 'King/Cal King'].forEach(sz => {
      const btn = document.createElement('button');
      btn.className = 'kyari-size-btn';
      btn.textContent = sz;
      btn.dataset.sizeValue = sz;

      btn.addEventListener('click', () => {
        document.querySelectorAll('.kyari-size-btn').forEach(b => b.classList.remove('is-selected'));
        btn.classList.add('is-selected');
        state.size = sz;

        filterSizedCards(sz);
        populateSummary();

        if (state.step <= sizeStepIndex) {
          advanceToStep(sizeStepIndex + 1);
        }
      });
      sizeGrid.appendChild(btn);
    });

    sizeStep.appendChild(sizeGrid);
    productsContainer.appendChild(sizeStep);
    funnelBlocks.push({ dom: sizeStep, type: 'size' });
    currentStepNum++;
  }

  const typeArray = Array.from(types);
  
  const editTitleLower = editNameAttr.toLowerCase();
  if (editTitleLower.includes('living')) {
    const strictOrder = ['Throw Blanket', 'Table Runner', 'Accent Pillow', 'Coaster'];
    typeArray.sort((a, b) => {
      let idxA = strictOrder.findIndex(t => a.includes(t));
      let idxB = strictOrder.findIndex(t => b.includes(t));
      if (idxA === -1) idxA = 99;
      if (idxB === -1) idxB = 99;
      return idxA - idxB;
    });
  } else if (editTitleLower.includes('spring')) {
    const strictOrder = ['Table Runner Set', 'Throw Blanket', 'Table Runner', 'Accent Pillow Cover'];
    typeArray.sort((a, b) => {
      let idxA = strictOrder.findIndex(t => a.includes(t));
      let idxB = strictOrder.findIndex(t => b.includes(t));
      if (idxA === -1) idxA = 99;
      if (idxB === -1) idxB = 99;
      return idxA - idxB;
    });
  } else {
    typeArray.sort((a, b) => a.includes('Bed') ? -1 : 1);
  }

  typeArray.forEach(type => {
    const stepIndex = currentStepNum;
    const stepDOM = createStepContainer(stepIndex, `Select ${type}`);
    const grid = document.createElement('div');
    grid.className = 'kyari-tier-grid';

    let typeCards = [];
    cards.forEach(card => {
      if (card.dataset.productType === type) typeCards.push(card);
    });

    typeCards.forEach((card) => {
      card.dataset.matchesSize = 'true';
      grid.appendChild(card);
      setupCardInteractions(card, type, stepIndex);
    });

    stepDOM.appendChild(grid);

    if (typeCards.length > 6) {
      const showMoreWrapper = document.createElement('div');
      showMoreWrapper.className = 'kyari-show-more-wrapper center';
      showMoreWrapper.style.marginTop = '3rem';

      const showMoreBtn = document.createElement('button');
      showMoreBtn.className = 'button button--secondary kyari-show-more-btn';
      showMoreBtn.textContent = `View more options`;
      showMoreBtn.dataset.expanded = 'false';

      showMoreBtn.addEventListener('click', (e) => {
        e.preventDefault();
        const isExpanded = showMoreBtn.dataset.expanded === 'true';

        if (isExpanded) {
          showMoreBtn.dataset.expanded = 'false';
          showMoreBtn.textContent = 'View more options';
          const gridRect = grid.getBoundingClientRect().top;
          window.scrollBy({ top: gridRect - 150, behavior: 'smooth' });
        } else {
          showMoreBtn.dataset.expanded = 'true';
          showMoreBtn.textContent = 'Show less options';
        }
        applyPaginationToStep(stepDOM);
      });

      showMoreWrapper.appendChild(showMoreBtn);
      stepDOM.appendChild(showMoreWrapper);
    }

    productsContainer.appendChild(stepDOM);
    funnelBlocks.push({ dom: stepDOM, type: type });
    currentStepNum++;
  });

  const finalStepIndex = currentStepNum;
  const summaryStep = createStepContainer(finalStepIndex, 'Review Your Edit');

  const summaryContent = document.createElement('div');
  summaryContent.className = 'kyari-final-summary';
  summaryContent.innerHTML = `
    <div id="KyariSummaryItems" style="text-align: left; max-width: 500px; margin: 0 auto;"></div>
    <div class="kyari-final-total">
      <span>Bundle Total:</span>
      <span id="KyariFinalPrice">--</span>
    </div>
    <p class="kyari-tax-note">Taxes & native bundle discounts applied accurately at checkout.</p>
    <button id="KyariCheckoutBtn" class="button button--primary" style="margin: 20px auto 0 auto; display: block; min-width: 250px;">
      Add Bundle to Cart
    </button>
  `;
  summaryStep.appendChild(summaryContent);
  productsContainer.appendChild(summaryStep);
  funnelBlocks.push({ dom: summaryStep, type: 'summary' });

  // Initialize independent step paginations on load explicitly
  funnelBlocks.forEach(block => {
    if (block.type !== 'size' && block.type !== 'summary') {
      applyPaginationToStep(block.dom);
    }
  });

  function advanceToStep(targetStep) {
    if (targetStep > state.step) state.step = targetStep;

    funnelBlocks.forEach((block, index) => {
      const actualStep = index + 1;

      if (actualStep < state.step) {
        block.dom.classList.add('is-completed');
        block.dom.classList.remove('is-locked', 'is-active');
      } else if (actualStep === state.step) {
        block.dom.classList.add('is-active');
        block.dom.classList.remove('is-locked', 'is-completed');
      } else {
        block.dom.classList.add('is-locked');
        block.dom.classList.remove('is-active', 'is-completed');
      }
    });

    let blockScroll = (state.step === finalStepIndex)
      ? funnelBlocks[funnelBlocks.length - 1]
      : funnelBlocks[state.step - 1];

    if (blockScroll && blockScroll.dom) {
      let offset = window.innerWidth < 768 ? 80 : 120;
      let bodyRect = document.body.getBoundingClientRect().top;
      let elementRect = blockScroll.dom.getBoundingClientRect().top;
      let elementPosition = elementRect - bodyRect;
      let offsetPosition = elementPosition - offset;
      window.scrollTo({ top: offsetPosition, behavior: 'smooth' });
    }
  }

  function filterSizedCards(selectedSize) {
    let rawSearchKw = 'queen';
    let excludeKw = null;
    if (selectedSize === 'King/Cal King') {
      // Show all king-sized products — both regular King and Cal King variants
      rawSearchKw = 'king';
      excludeKw = null; // no exclusion — cal king is also valid
    }
    cards.forEach(card => {
      card.classList.remove('is-hidden-by-pagination', 'is-sold-out');

      if (card.dataset.hasSizes === 'true') {
        const kw = (card.dataset.productKeywords || "").toLowerCase();
        if (kw.includes(rawSearchKw)) {
          // Strict Exclusion for King vs Cal King
          if (excludeKw && kw.includes(excludeKw)) {
            card.dataset.matchesSize = 'false';
            return;
          }

          card.dataset.matchesSize = 'true';
          const variantSelect = card.querySelector('.kyari-product-card__variant-select');
          if (variantSelect) {
            let matchingOptions = Array.from(variantSelect.options).filter(opt => {
              const optText = opt.text.toLowerCase();
              if (excludeKw && optText.includes(excludeKw)) return false;
              return optText.includes(rawSearchKw);
            });
            if (matchingOptions.length === 0) {
              matchingOptions = Array.from(variantSelect.options);
            }
            const availableVariantFound = matchingOptions.find(opt => !opt.disabled);

            if (availableVariantFound) {
              card.classList.remove('is-sold-out');
              variantSelect.value = availableVariantFound.value;
              card.dataset.productId = availableVariantFound.value;

              const newImg = availableVariantFound.dataset.variantImage;
              if (newImg) {
                const pImg = card.querySelector('.kyari-primary-image img');
                if (pImg) pImg.src = newImg;
                card.dataset.productImage = newImg;
              }
            } else {
              card.classList.add('is-sold-out');
              card.dataset.productId = '';
            }
          }
        } else {
          card.dataset.matchesSize = 'false';
        }
      } else {
        card.dataset.matchesSize = 'true';
        card.classList.remove('is-sold-out');
        const variantSelect = card.querySelector('.kyari-product-card__variant-select');
        if (variantSelect) {
          const availableVariantFound = Array.from(variantSelect.options).find(opt => !opt.disabled);
          if (availableVariantFound) {
            variantSelect.value = availableVariantFound.value;
            card.dataset.productId = availableVariantFound.value;
            const newImg = availableVariantFound.dataset.variantImage;
            if (newImg) {
              const pImg = card.querySelector('.kyari-primary-image img');
              if (pImg) pImg.src = newImg;
              card.dataset.productImage = newImg;
            }
          } else {
            card.classList.add('is-sold-out');
            card.dataset.productId = '';
          }
        }
      }
    });

    funnelBlocks.forEach(block => {
      if (block.type !== 'size' && block.type !== 'summary') {
        applyPaginationToStep(block.dom);
      }
    });
  }

  function applyPaginationToStep(stepDOM) {
    const stepCards = Array.from(stepDOM.querySelectorAll('.kyari-product-card'));
    const visibleCards = stepCards.filter(c => c.dataset.matchesSize !== 'false');
    const hiddenDueToSize = stepCards.filter(c => c.dataset.matchesSize === 'false');

    hiddenDueToSize.forEach(c => c.style.display = 'none');

    const showMoreBtn = stepDOM.querySelector('.kyari-show-more-btn');
    const wrapper = stepDOM.querySelector('.kyari-show-more-wrapper');

    if (visibleCards.length <= 6) {
      if (wrapper) wrapper.style.display = 'none';
      visibleCards.forEach(c => {
        c.style.display = 'block';
        c.classList.remove('is-hidden-by-pagination');
      });
    } else {
      if (wrapper) wrapper.style.display = 'block';

      const isExpanded = showMoreBtn && showMoreBtn.dataset.expanded === 'true';
      if (!isExpanded) {
        let limit = 6;
        visibleCards.forEach((c) => {
          // Protect selected item from being collapsed!
          if (c.classList.contains('is-selected')) {
            c.classList.remove('is-hidden-by-pagination');
            c.style.display = 'block';
          } else if (limit > 0) {
            c.classList.remove('is-hidden-by-pagination');
            c.style.display = 'block';
            limit--;
          } else {
            c.classList.add('is-hidden-by-pagination');
            c.style.display = 'none';
          }
        });
      } else {
        visibleCards.forEach(c => {
          c.classList.remove('is-hidden-by-pagination');
          c.style.display = 'block';
        });
      }
    }
  }

  function setupCardInteractions(card, type, stepIndex) {
    const actionBtn = card.querySelector('.kyari-product-card__action');
    const carouselWrapper = card.querySelector('.kyari-product-card__carousel');
    const primaryImg = card.querySelector('.kyari-primary-image');
    const variantSelect = card.querySelector('.kyari-product-card__variant-select');

    card.addEventListener('click', (e) => {
      if (e.target.classList.contains('kyari-carousel-prev') || e.target.classList.contains('kyari-carousel-next') || e.target.classList.contains('kyari-product-card__variant-select')) return;

      const peers = card.closest('.kyari-tier-grid').querySelectorAll('.kyari-product-card');
      peers.forEach(p => {
        p.classList.remove('is-selected');
        p.querySelector('.kyari-product-card__action').textContent = 'Select';
        const cWrapper = p.querySelector('.kyari-product-card__carousel');
        const pImg = p.querySelector('.kyari-primary-image');
        if (cWrapper) cWrapper.style.display = 'none';
        if (pImg) pImg.style.display = 'block';
      });

      card.classList.add('is-selected');
      actionBtn.textContent = 'Selected ✓';

      if (carouselWrapper && primaryImg) {
        primaryImg.style.display = 'none';
        carouselWrapper.style.display = 'block';
        initCarousel(carouselWrapper);
      }

      let fullTitle = card.querySelector('.kyari-product-card__title').textContent;
      if (variantSelect) {
        let selectedOptText = variantSelect.options[variantSelect.selectedIndex].text.split(' - ')[0];
        fullTitle += ` - ${selectedOptText}`;
        card.dataset.productId = variantSelect.value;
      }

      state.selections[type] = {
        id: card.dataset.productId,
        title: fullTitle,
        img: card.dataset.productImage
      };

      populateSummary();

      // Support Backwards Flow Editing without auto-scrolling jarringly
      if (state.step <= stepIndex) {
        setTimeout(() => { advanceToStep(stepIndex + 1); }, 400);
      }
    });

    const triggerVariantSwap = () => {
      const selectedOpt = variantSelect.options[variantSelect.selectedIndex];
      const newImageSrc = selectedOpt.dataset.variantImage;
      card.dataset.productId = variantSelect.value;

      if (newImageSrc) {
        if (primaryImg) {
          const primaryImgEl = primaryImg.querySelector('img');
          if (primaryImgEl) {
            primaryImgEl.removeAttribute('srcset');
            primaryImgEl.src = newImageSrc;
          }
        }

        // Re-bind exact variant image into carousel start frame structurally!
        if (carouselWrapper) {
          const firstSlideImg = carouselWrapper.querySelector('.kyari-carousel-slide img');
          if (firstSlideImg) {
            firstSlideImg.removeAttribute('srcset');
            firstSlideImg.src = newImageSrc;
          }
          const track = carouselWrapper.querySelector('.kyari-carousel-track');
          if (track) track.style.transform = `translateX(0%)`;
          carouselWrapper.dataset.currentIndex = 0;
        }

        card.dataset.productImage = newImageSrc;
      }

      if (card.classList.contains('is-selected')) {
        let fullTitle = card.querySelector('.kyari-product-card__title').textContent;
        let selectedOptText = selectedOpt.text.split(' - ')[0];
        fullTitle += ` - ${selectedOptText}`;

        state.selections[type] = {
          id: variantSelect.value,
          title: fullTitle,
          img: card.dataset.productImage
        };
        populateSummary();
      }
    };

    if (variantSelect) {
      variantSelect.addEventListener('change', triggerVariantSwap);
    }
  }

  function createStepContainer(number, title) {
    const div = document.createElement('div');
    div.className = 'kyari-funnel-step ' + (number === 1 ? 'is-active' : 'is-locked');
    div.innerHTML = `
      <div class="kyari-funnel-header">
        <div class="kyari-funnel-number">0${number}</div>
        <h2 class="kyari-funnel-title h2">${title}</h2>
      </div>
      <div class="kyari-funnel-body"></div>
    `;
    const ogAppend = div.appendChild.bind(div);
    div.appendChild = (node) => {
      if (node.classList && node.classList.contains('kyari-funnel-header')) ogAppend(node);
      else div.querySelector('.kyari-funnel-body').appendChild(node);
    };
    return div;
  }

  function populateSummary() {
    const itemsContainer = document.getElementById('KyariSummaryItems');
    if (!itemsContainer) return;
    itemsContainer.innerHTML = '';

    if (state.size) {
      itemsContainer.innerHTML += `
         <div class="kyari-summary-line" style="display:flex; padding-bottom:1rem; border-bottom:1px solid #eaeaea;">
            <div style="font-size:0.85rem; color:#a8a39a; text-transform:uppercase; letter-spacing:0.05em; width:120px;">Bed Size</div>
            <strong style="font-size:1.1rem; color:#4a4a4a; font-weight:400;">${state.size}</strong>
         </div>
       `;
    }

    Object.keys(state.selections).forEach(type => {
      const item = state.selections[type];
      itemsContainer.innerHTML += `
         <div class="kyari-summary-line" style="display:flex; align-items:center; gap: 1.5rem; margin-top: 1.5rem; padding-bottom:1.5rem; border-bottom:1px solid #eaeaea;">
            <img src="${item.img}" style="width: 70px; height: 70px; object-fit:cover; border-radius:4px; border: 1px solid #eaeaea;">
            <div>
               <div style="font-size:0.85rem; color:#a8a39a; text-transform:uppercase; letter-spacing:0.05em; margin-bottom:0.2rem;">${type}</div>
               <strong style="font-size:1.1rem; color:#4a4a4a; font-weight:400;">${item.title}</strong>
            </div>
         </div>
       `;
    });

    const priceSpan = document.getElementById('KyariFinalPrice');
    if (priceSpan) {
      if (bundlePriceCents > 0) {
        const dollars = (bundlePriceCents / 100).toFixed(2);
        priceSpan.innerHTML = `$${dollars}`;
      } else if (editNameAttr.toLowerCase().includes('spring')) {
        priceSpan.innerHTML = '$175.00';
      } else if (state.size && state.size.includes('Queen')) {
        priceSpan.innerHTML = '$100.00';
      } else if (state.size && state.size.includes('King')) {
        // Covers both 'King/Cal King' (merged) — flat $125
        priceSpan.innerHTML = '$125.00';
      } else {
        priceSpan.innerHTML = 'Discounts natively apply at checkout';
      }
    }
  }

  function initCarousel(wrapper) {
    if (wrapper.dataset.initialized) return;
    wrapper.dataset.initialized = 'true';
    wrapper.dataset.currentIndex = 0;

    const track = wrapper.querySelector('.kyari-carousel-track');
    const slides = track.querySelectorAll('.kyari-carousel-slide');
    const prev = wrapper.querySelector('.kyari-carousel-prev');
    const next = wrapper.querySelector('.kyari-carousel-next');

    if (slides.length <= 1) {
      prev.style.display = 'none';
      next.style.display = 'none';
      return;
    }

    function update() {
      let cIdx = parseInt(wrapper.dataset.currentIndex || 0);
      track.style.transform = `translateX(-${cIdx * 100}%)`;
    }

    next.addEventListener('click', (e) => {
      e.stopPropagation();
      let cIdx = parseInt(wrapper.dataset.currentIndex || 0);
      if (cIdx < slides.length - 1) cIdx++;
      else cIdx = 0;
      wrapper.dataset.currentIndex = cIdx;
      update();
    });

    prev.addEventListener('click', (e) => {
      e.stopPropagation();
      let cIdx = parseInt(wrapper.dataset.currentIndex || 0);
      if (cIdx > 0) cIdx--;
      else cIdx = slides.length - 1;
      wrapper.dataset.currentIndex = cIdx;
      update();
    });
  }

  document.addEventListener('click', async (e) => {
    if (e.target && e.target.id === 'KyariCheckoutBtn') {
      e.target.disabled = true;
      e.target.textContent = 'Curating Edit...';

      let bundleId = 'KyariEdit_' + Date.now();
      if (editNameAttr.toLowerCase().includes('spring')) {
        bundleId = 'Spring_' + Date.now();
      }

      // Determine effective bundle price in cents (use DOM data attr, fall back to size inference)
      let effectiveBundlePrice = bundlePriceCents;
      if (!effectiveBundlePrice) {
        const editLower = editNameAttr.toLowerCase();
        if (editLower.includes('spring')) effectiveBundlePrice = 17500;
        else if (editLower.includes('living')) effectiveBundlePrice = 10500;
        else if (state.size) {
          if (state.size.includes('King')) effectiveBundlePrice = 12500; // King/Cal King unified at $125
          else effectiveBundlePrice = 10000; // Queen
        }
      }

      const rawItems = Object.entries(state.selections).map(([itemType, item]) => {
        const isSheet = itemType.toLowerCase().includes('bed');
        /** @type {Record<string, string|null>} */
        const props = {
          '_Edit': `KYĀRĪ EDIT | ${editNameAttr}`,
          '_Kyari_Bundle': bundleId,
          '_Kyari_Bundle_Price': String(effectiveBundlePrice),
          '_Kyari_Expected_Items': String(Object.keys(state.selections).length),
          '_Kyari_Size': state.size
        };
        if (isSheet && state.size) props['Bed Size'] = state.size;
        return {
          id: parseInt(item.id, 10),
          quantity: 1,
          properties: props
        };
      });

      try {
        const response = await fetch('/cart/add.js', {
          method: 'POST',
          headers: { 'Content-Type': 'application/json' },
          body: JSON.stringify({ items: rawItems })
        });
        if (response.ok) {
          window.location.href = '/cart';
        } else {
          const err = await response.json();
          alert('Error: ' + err.description);
          e.target.disabled = false;
          e.target.textContent = 'Add Bundle to Cart';
        }
      } catch (error) {
        console.error(error);
        e.target.disabled = false;
      }
    }
  });
});

/* ============================================================================
   CURATED SETS (1-CLICK AJAX BUNDLES)
   ============================================================================ */

document.addEventListener('DOMContentLoaded', () => {
  const curatedBtns = document.querySelectorAll('.kyari-add-curated-btn');
  
  curatedBtns.forEach(btn => {
    btn.addEventListener('click', (e) => {
      e.preventDefault();
      const variantIdsRaw = btn.dataset.variants || '';
      const bundlePrice = btn.dataset.price || '0';
      
      const variantIds = variantIdsRaw.split(',').map(id => id.trim()).filter(id => id.length > 0);
      
      if (variantIds.length === 0) {
        alert('No variants configured for this bundle.');
        return;
      }
      
      const originalText = btn.textContent;
      btn.textContent = 'Adding to Cart...';
      btn.disabled = true;
      
      const items = variantIds.map(id => ({
        id: parseInt(id, 10),
        quantity: 1,
        properties: {
          '_Kyari_Bundle_Price': bundlePrice
        }
      }));
      
      fetch((window.Shopify && window.Shopify.routes ? window.Shopify.routes.root : '/') + 'cart/add.js', {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json'
        },
        body: JSON.stringify({ items: items })
      })
      .then(response => {
        if (!response.ok) throw new Error('network response was not ok');
        return response.json();
      })
      .then(data => {
        btn.textContent = 'Added to Cart!';
        document.dispatchEvent(new CustomEvent('cart:build')); // Try to trigger generic drawer update
        setTimeout(() => {
          window.location.href = '/cart'; // Force redirect to cart so they see the whole bundle instantly
        }, 600);
      })
      .catch(error => {
        console.error('Error adding curated bundle:', error);
        btn.textContent = 'Error Adding Bundle';
        setTimeout(() => {
          btn.textContent = originalText;
          btn.disabled = false;
        }, 2000);
      });
    });
  });
});
